// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { Checkbox, Col, Divider, Form, Row } from "antd";
import { getModuleAccessAPI, getModulesAPI } from "services/system_setup/role_access";
import { UserAccessContext } from "context/userAccess";

const CheckboxGroup = Checkbox.Group;

const AddModuleAccess = (props) => {
    const { userAccess } = useContext(UserAccessContext);
    const updateRight = userAccess['systemSetup'].update;

    const [modules, setModules] = useState([]);
    const [moduleAccess, setModuleAccess] = useState([]);
    const [accessTypes, setAccessTypes] = useState([]);

    async function getList(){
        const resModules = await getModulesAPI();
        const resModuleAccess = await getModuleAccessAPI();
        const selectedModule = resModules.filter((item) => item.module_code === props.moduleCode);
        
        setModules(selectedModule);
        setModuleAccess(resModuleAccess);
    }

    useEffect(()=> {
        getList();
    }, [props.moduleCode]);

    // useEffect(()=> {
    //     props.moduleAccessValues(accessTypes)
    // }, [accessTypes]);

    const handleAccessOnChange = (e)=> {
        const accessTypeName = e.target.id;
        if(e.target.checked === true){
            setAccessTypes(accessTypes => [...accessTypes, accessTypeName]);
        }else{
            setAccessTypes((items) => 
                items.filter((value) => value !== accessTypeName)
            );
        }
    }

    const displayModules = modules.map(item => {
        const filterAccess = moduleAccess.filter((acc) => acc.module_code === item.module_code)

        const displayAccess = filterAccess.map(item => {
            return(
                <div>
                {(item.is_active === true)
                    ?   <Form.Item name={ item.module_access_code } valuePropName='checked' >
                            <Checkbox key={item.access_type_name} value={item.access_type_name} 
                                onChange={ handleAccessOnChange }
                                disabled={updateRight === 'TRUE' ? false : true}
                            >{ item.access_type_name }</Checkbox>
                        </Form.Item>
                    :   <Form.Item name={ item.module_access_code } >
                            <Checkbox disabled>{ item.access_type_name }</Checkbox>
                        </Form.Item>
                }
                </div>
            );
        });

        return(
            <CheckboxGroup>
            <Row gutter ={[8 , 1]} justify="space-around" align="top" >                        
                <Col span={24} >
                    <Divider orientation="left">{ item.module_name }</Divider>
                        {displayAccess}
                </Col>
            </Row>
            </CheckboxGroup>
        )
    });

    return (
        <div>{displayModules}</div>
    )
};

export default AddModuleAccess;